module.exports = __webpack_public_path__ + "static/media/fly0018.bded7ac7.webp";